import React from 'react';
import CustomNavbar from '../components/CustomNavbar';
import DesignBanner from '../components/Banner/DesignBanner';
import News from '../components/News/News';
import Docs from '../components/Docs/Docs';
import FooterTwo from '../components/Footer/FooterTwo';
import FooterData from '../components/Footer/FooterData';
import GetInTouch from '../components/GetInTouch';
import Metrics from '../components/Metrics'
import ServiceSubscribe from '../components/ServiceSubscribe'
import ImageBanner from '../components/Banner/ImageBanner'

const whitePapers = [
    { teamImage: 'whitepaper_01.png', title:"Predicting Product Temperatures", fileName: 'Hemdahl_WP_101_Predicting_Product_Temperatures.pdf' },
    { teamImage: 'whitepaper_02.png', title:"Pathogen Growth Prediction", fileName: 'Hemdahl_WP_102_Pathogen_Growth_Prediction.pdf' },
    { teamImage: 'whitepaper_03.png', title:"Shelf Life Prediction", fileName: 'Hemdahl_WP_103_Shelf_Life_Prediction.pdf' },
    { teamImage: 'whitepaper_04.png', title:"Cold Treatment Verification", fileName: 'Hemdahl_WP_104_Cold_Treatment_Verification.pdf' },
]

export const Home = () => (
    <div className="body_wrapper">
        <CustomNavbar cClass="custom_container p0" hbtnClass="new_btn"/>
        <DesignBanner/>
        <ImageBanner fileName="banner_tragedy.png" />
        <ImageBanner fileName="banner_quality.png" />
        <ImageBanner fileName="banner_available.png" />
        <GetInTouch/>
        <Docs title="Whitepapers" docs={whitePapers} />
        <News/>
        <Metrics/>
        <ServiceSubscribe/>
        <FooterTwo FooterData={FooterData}/>
    </div>
)